// extracted by mini-css-extract-plugin
export default {"heading":"FormTitle_heading__SditF","header":"FormTitle_header__h6Wj+"};